import { createContext } from "react";

const GlobalContext=createContext({
    user:{},
    language:{}
})



export {GlobalContext}